<script setup lang="ts">
import { Checkbox } from '@/ui/checkbox'

const props = defineProps<{
  id: string
  modelValue: boolean | unknown[]
  value?: unknown
  label?: string
  description?: string
  disabled?: boolean
}>()

const emit = defineEmits<(e: 'update:modelValue', value: boolean | unknown[]) => void>()

defineSlots<{
  label?: () => unknown
  description?: () => unknown
}>()

const isChecked = computed(() => {
  if (Array.isArray(props.modelValue)) return props.modelValue.includes(props.value)
  return !!props.modelValue
})

function handleUpdate(checked: boolean) {
  if (Array.isArray(props.modelValue)) {
    emit(
      'update:modelValue',
      checked
        ? props.modelValue.includes(props.value)
          ? props.modelValue
          : [...props.modelValue, props.value]
        : props.modelValue.filter((v) => v !== props.value)
    )
  } else {
    emit('update:modelValue', checked)
  }
}
</script>

<template>
  <label
    :for="id"
    :class="[
      'flex gap-2',
      description || $slots.description ? 'items-start' : 'items-center',
      disabled ? 'cursor-default opacity-60' : 'cursor-pointer'
    ]"
  >
    <div class="flex h-5 items-center">
      <Checkbox :id="id" :model-value="isChecked" :disabled="disabled" @update:model-value="handleUpdate(!!$event)" />
    </div>
    <div class="text-sm">
      <span class="text-foreground">
        <slot name="label">{{ label }}</slot>
      </span>
      <p v-if="description || $slots.description" class="mt-1 text-muted-foreground">
        <slot name="description">{{ description }}</slot>
      </p>
    </div>
  </label>
</template>
